/* eslint-disable array-bracket-newline */
/* eslint-disable multiline-ternary */
// ** Reactstrap Imports
import {
  // useCallback,
  useEffect,
  // useRef,
  useState,
} from "react";
import {
  Calendar,
  Check,
  Film,
  HardDrive,
  Link,
  Music,
  X,
  MessageSquare,
  Edit,
  PlusCircle,
  MessageCircle,
  ChevronUp,
  ChevronDown,
} from "react-feather";
import Breadcrumbs from "@components/breadcrumbs";

import {
  Table,
  Badge,
  Button,
  Input,
  Col,
  Row,
  DropdownMenu,
  DropdownToggle,
  ButtonDropdown,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Collapse,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  UncontrolledAccordion,
} from "reactstrap";
// import { debounce } from "lodash";

import Talk from "talkjs";

import Select from "react-select";
import Flatpickr from "react-flatpickr";

import { selectThemeColors } from "@utils";

// ** Styles Imports
// import "flatpickr/dist/flatpickr.css";
import "@styles/react/libs/react-select/_react-select.scss";
import "@styles/react/libs/flatpickr/flatpickr.scss";

import Feedback from "../../apps/myprojects/Feedback";
import { useNavigate } from "react-router-dom";
import { ADMIN_ROUTES } from "../../../constant/route";
// import { getProjects } from "../../../redux/projectManagement/projectManagement.thunk";
import { useDispatch, useSelector } from "react-redux";
import LineSkelaton from "../../../common/skeleton/LineSkelaton";
import {
  projectTitle,
  ststusOptions,
  //   ststusOptionsTab,
} from "../projectManagement/common/utils";
import {
  ChangeStatus,
  // etaEstimationDate,
} from "../../../services/projectManagementService";
import ToastContent from "../../components/toast/toast";
import toast from "react-hot-toast";
// import moment from "moment";
import ReactPaginate from "react-paginate";
import { PerPaginationPageData } from "../../../constant/constant";
import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";
import ReactDatePicker from "react-datepicker";
import {
  dateFormat,
  renderMessageSegments,
} from "../../../common/functions/helperFunctions";
import AddLink from "../projectManagement/component/AddLink";
import UILoader from "@components/ui-loader";
// ** Config
// import themeConfig from "@configs/themeConfig";
import Loader from "../../../common/Loader/Loader";
// import { getEditors } from "../../../redux/editorsMaster/editorsMaster.thunk";
// import { assignProjectEditor } from "../../../services/EditorsMaster/editorsMaster.services";
import Cleave from "cleave.js";
import { getArchivedProjects } from "../../../redux/archivedProjects/archivedProjects.thunks";
import { unarchiveProject } from "../../../services/ArchivedProjects/archivedProjects.services";
import { ReactComponent as UnArchiveIcon } from "../../../assets/images/pages/unarchive.svg";

// ** ststusOptions

const ArchivedProjects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [isListApiCall, setIsListApiCall] = useState(true);

  const projects = useSelector(
    (state) => state.archivedProjects.archivedProjectsList
  );

  const Previous = () => {
    return <span className="align-middle d-none d-md-inline-block">Prev</span>;
  };

  const Next = () => {
    return <span className="align-middle d-none d-md-inline-block">Next </span>;
  };

  const getProjectStatus = (status) => {
    const result = ststusOptions.filter((item) => item.value === status);
    if (result.length) {
      return result[0];
    }
  };

  // handle paginations
  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
    setIsListApiCall(!isListApiCall);
  };

  const handleUnArchive = (subProjectId) => {
    const payload = {
      id: subProjectId,
    };

    unarchiveProject(payload)
      .then((res) => {
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.message}
            icon={<Check size={12} />}
            color="success"
          />
        ));
        setIsListApiCall(!isListApiCall);
      })
      .catch((err) => {
        console.log("err: ", err);
        getErrorMsg(err);
      });
  };

  const getListData = () => {
    const payload = { user_id: "all", page: currentPage };
    dispatch(getArchivedProjects(payload));
    setIsListApiCall(!isListApiCall);
  };

  useEffect(() => {
    if (isListApiCall) getListData();
  }, [isListApiCall]);

  return (
    <>
      <Breadcrumbs
        title="All Archived Projects"
        data={[{ title: "All Archived Projects", link: "" }]}
      />

      <UILoader blocking={projects.isFetching} loader={<Loader />}>
        <div className="project-table">
          <Table hover>
            <thead>
              <tr>
                <th style={{ minWidth: "105px" }}>No.</th>
                <th style={{ minWidth: "200px" }}>Company Name </th>
                <th style={{ minWidth: "137px" }}>Order Date</th>
                <th style={{ minWidth: "270px" }}>Project Name</th>
                <th style={{ minWidth: "475px" }}>Project Type</th>
                <th style={{ minWidth: "475px" }}>Language</th>
                <th style={{ minWidth: "250px" }}>NLE Software</th>
                <th style={{ minWidth: "250px" }}>Footage</th>
                <th>Feedback</th>
                <th style={{ minWidth: "250px" }}>Privacy Policy </th>
                <th style={{ minWidth: "250px" }}>Review Link</th>
                <th style={{ minWidth: "250px" }}>Project status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {projects?.data?.data?.map((row) => (
                <tr key={row.id}>
                  <td>{row.sr_no}</td>
                  <td
                    className={`${
                      row?.subscription_id !== null ? "table-custom-column" : ""
                    }`}
                    onClick={() =>
                      navigate(ADMIN_ROUTES.CLIENT_DETAIL, {
                        state: row.user_id,
                      })
                    }
                  >
                    <p className="custom-project-table-width">
                      {row.company_name ? row.company_name : "-"}
                    </p>
                  </td>
                  <td style={{ minWidth: "170px" }}>
                    {row.invoice_due_date
                      ? dateFormat(row.invoice_due_date)
                      : "-"}
                  </td>
                  <td
                    className="click-name break-word"
                    onClick={() =>
                      navigate(ADMIN_ROUTES.PROJECT_INFO, {
                        state: row.sub_project_id,
                      })
                    }
                  >
                    <p className="custom-project-table-width ">
                      {row.project_name}
                    </p>
                  </td>
                  <td>
                    <p className="custom-project-type-td text-capitalize">
                      {projectTitle(row.sub_order)}
                    </p>
                  </td>

                  <td className="text-capitalize">
                    <p className="custom-project-type-td">
                      {row?.wedding_language === null
                        ? "--"
                        : row?.wedding_language}
                    </p>
                  </td>
                  <td style={{ textTransform: "uppercase" }}>
                    <p className="custom-project-type-td">
                      {row?.nle_software === null
                        ? "--"
                        : row?.nle_software.replace(/_/g, " ")}
                    </p>
                  </td>
                  <td>
                    {row?.footage_transfer_method ? (
                      row?.footage_transfer_method === "online" ? (
                        <a
                          className="click-name"
                          href={row.online_footage_link}
                          target="__blank"
                        >
                          Link
                        </a>
                      ) : (
                        <div>
                          <p>{row.tracking_number}</p>
                          <p>{row.shipping_service_text}</p>
                        </div>
                      )
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="click-name list-feedback-msg">
                    <div className="chat-with-icon">
                      <label className="chat-icon-tb cursor-pointer position-relative">
                        <MessageSquare />
                      </label>
                    </div>
                  </td>
                  <td>
                    <p className="custom-project-type-td text-capitalize">
                      {row?.privacy_policy === null
                        ? "--"
                        : row?.privacy_policy?.replace(/_/g, " ")}
                    </p>
                  </td>

                  {row.project_review_link ? (
                    <td>
                      <Row>
                        <Col
                          xl={10}
                          xxl={8}
                          md={10}
                          sm={10}
                          className="click-name list-feedback-msg"
                        >
                          <p>
                            {renderMessageSegments(row.project_review_link)}
                          </p>
                        </Col>
                        <Col xl={2} md={2} sm={2} xxl={2}>
                          <Edit size={16} className="me-5" />
                        </Col>
                      </Row>
                    </td>
                  ) : (
                    <td>
                      <PlusCircle />
                    </td>
                  )}

                  <td>
                    {row?.project_status === "approved_by_client" ? (
                      "Approved By Client"
                    ) : (
                      <Select
                        menuPortalTarget={document.body}
                        id="filter"
                        isDisabled
                        placeholder="Select Filter"
                        className="react-select custom-table-react-se"
                        classNamePrefix="select"
                        isClearable={false}
                        options={ststusOptions}
                        theme={selectThemeColors}
                        value={getProjectStatus(row?.project_status)}
                      />
                    )}
                  </td>
                  <td>
                    <Button.Ripple
                      className="btn-icon rounded-circle me-50"
                      color="flat-primary"
                      onClick={() => handleUnArchive(row.sub_project_id)}
                    >
                      <UnArchiveIcon />
                    </Button.Ripple>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="no_data">
            {projects?.isFetching === false &&
              projects?.data?.data?.length === 0 && (
                <Card>
                  <p>No Data are found</p>
                </Card>
              )}
            {projects?.isFetching === true && (
              <div>
                {[...Array(5)].map((_, i) => (
                  <LineSkelaton key={i} />
                ))}
              </div>
            )}
          </div>
        </div>
      </UILoader>
      <div className="d-flex justify-content-end custom-pagination">
        <ReactPaginate
          pageCount={projects?.data?.last_page}
          breakLabel="..."
          nextLabel={<Next />}
          pageRangeDisplayed={1}
          marginPagesDisplayed={2}
          activeClassName="active"
          pageClassName="page-item"
          breakClassName="page-item"
          previousLabel={<Previous />}
          nextLinkClassName="page-link"
          pageLinkClassName="page-link"
          nextClassName="page-item next"
          breakLinkClassName="page-link"
          previousClassName="page-item prev"
          previousLinkClassName="page-link"
          containerClassName={`pagination react-paginate ${
            (projects?.isFetching === true ||
              projects?.data?.data?.length === 0) &&
            "d-none"
          }`}
          onPageChange={(page) => handlePagination(page)}
        />
      </div>
    </>
  );
};

export default ArchivedProjects;
